module.exports = __webpack_public_path__ + "img/ag.f6adf542.svg";